export default {
  AccountCenter: {
    title: '账号中心',
    accountInfo: '账号信息',
    accountManagement: '账号管理',
    name: '姓名',
    phone: '手机号',
    email: '邮箱',
    department: '部门',
    password: '密码',
    verified: '已验证',
    configured: '已设置',
    changePassword: '修改密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    oldPasswordPlaceholder: '请输入原密码',
    newPasswordPlaceholder: '请输入8-20位新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    passwordLengthTip: '密码长度为8-20位',
    confirmChange: '确认修改',
    oldPasswordRequired: '请输入原密码',
    newPasswordRequired: '请输入新密码',
    confirmPasswordRequired: '请再次输入新密码',
    passwordLengthError: '密码长度须为8-20位',
    passwordCharacterError: '仅支持英文字母、数字及英文半角特殊字符，不支持空格',
    passwordNotMatch: '两次输入的新密码不一致',
    passwordUpdateSuccess: '密码修改成功',
    defaultPasswordWarningTitle: '密码安全提醒',
    defaultPasswordWarningMessage: '当前账号仍在使用默认密码，为保障账号安全，请尽快修改密码。',
    changePasswordNow: '立即修改',
  },
};
